import React, { useState } from 'react';
import { useForm } from 'antd/lib/form/Form';
import {
  Avatar,
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Card,
  Typography,
  Divider,
  Space,
  Tag,
  Tooltip,
  Spin,
} from 'antd';
import { editUserApi } from '../../../api/user';
import NoAvatar from '../../../assets/img/png/no-avatar.png';
import './Profile.scss';

import { getAccessTokenApi, logout } from '../../../api/auth';
import {
  PoweroffOutlined,
  EditOutlined,
  UserOutlined,
  MailOutlined,
  IdcardOutlined,
  TeamOutlined,
  SettingOutlined,
  LockOutlined,
  InfoCircleOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import paths from 'assets/routes/paths';
import SetPasswordForm from 'components/forms/SetPasswordForm';
const userDataMap = {
  fullname: {
    label: 'Nombre Completo',
    icon: <UserOutlined />,
    color: '#1890ff',
  },
  type: {
    label: 'Tipo de Usuario',
    icon: <TeamOutlined />,
    color: '#52c41a',
  },
  email: {
    label: 'Correo Electrónico',
    icon: <MailOutlined />,
    color: '#fa8c16',
  },
  rut: {
    label: 'RUT',
    icon: <IdcardOutlined />,
    color: '#722ed1',
  },
  cargo: {
    label: 'Cargo',
    icon: <SettingOutlined />,
    color: '#eb2f96',
  },
  especialidad: {
    label: 'Especialidad',
    icon: <InfoCircleOutlined />,
    color: '#13c2c2',
  },
  otros: {
    label: 'Información Adicional',
    icon: <InfoCircleOutlined />,
    color: '#8c8c8c',
  },
};

function Profile(props) {
  const { user, onClose } = props;
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpen = () => {
    setOpen(!open);
  };

  const navigate = useNavigate();

  const logoutAction = () => {
    setLoading(true);
    setTimeout(() => {
      logout();
      navigate(paths.login);
    }, 1000);
  };

  const { Title, Text } = Typography;

  return (
    <div className="h-full bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
      {/* Close Button for Mobile */}

      <Modal
        open={open}
        onCancel={handleOpen}
        title={
          <div className="flex items-center space-x-2">
            <LockOutlined className="text-blue-500" />
            <span>Cambiar Contraseña</span>
          </div>
        }
        footer={false}
        width={500}
        centered
      >
        <SetPasswordForm finish={handleOpen} />
      </Modal>

      <div className="max-w-4xl mx-auto">
        {/* Header Card */}
        <Card className="mb-6 shadow-lg border-0">
          <div className="text-center">
            <div className="relative inline-block">
              <Avatar
                className="border-4 border-white shadow-lg"
                src={NoAvatar}
                size={120}
                icon={<UserOutlined />}
              />
              <div className="absolute -bottom-2 -right-2 bg-green-500 rounded-full p-1 border-2 border-white">
                <div className="w-3 h-3 bg-green-400 rounded-full"></div>
              </div>
            </div>

            <Title level={2} className="mt-4 mb-2">
              {user?.fullname || 'Usuario'}
            </Title>

            <Tag
              color="blue"
              className="text-sm px-3 py-1 rounded-full"
              icon={<TeamOutlined />}
            >
              {user?.type || 'Usuario'}
            </Tag>
          </div>
        </Card>

        {/* Information Cards */}
        <Row gutter={[16, 16]} className="mb-6">
          <Col xs={24} lg={12}>
            <Card
              title={
                <div className="flex items-center space-x-2">
                  <UserOutlined className="text-blue-500" />
                  <span>Información Personal</span>
                </div>
              }
              className="h-full shadow-md hover:shadow-lg transition-shadow"
            >
              <Space direction="vertical" size="middle" className="w-full">
                {Object.keys(userDataMap)
                  .filter((key) => ['fullname', 'email', 'rut'].includes(key))
                  .map((objKey) =>
                    user[objKey] ? (
                      <div
                        key={objKey}
                        className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-50 transition-colors"
                      >
                        <div
                          className="w-8 h-8 rounded-full flex items-center justify-center"
                          style={{
                            backgroundColor: `${userDataMap[objKey].color}20`,
                          }}
                        >
                          <span style={{ color: userDataMap[objKey].color }}>
                            {userDataMap[objKey].icon}
                          </span>
                        </div>
                        <div className="flex-1">
                          <Text strong className="text-gray-600">
                            {userDataMap[objKey].label}
                          </Text>
                          <div className="text-gray-800 font-medium">
                            {user[objKey]}
                          </div>
                        </div>
                      </div>
                    ) : null
                  )}
              </Space>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card
              title={
                <div className="flex items-center space-x-2">
                  <SettingOutlined className="text-green-500" />
                  <span>Información Laboral</span>
                </div>
              }
              className="h-full shadow-md hover:shadow-lg transition-shadow"
            >
              <Space direction="vertical" size="middle" className="w-full">
                {Object.keys(userDataMap)
                  .filter((key) =>
                    ['type', 'cargo', 'especialidad', 'otros'].includes(key)
                  )
                  .map((objKey) =>
                    user[objKey] ? (
                      <div
                        key={objKey}
                        className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-50 transition-colors"
                      >
                        <div
                          className="w-8 h-8 rounded-full flex items-center justify-center"
                          style={{
                            backgroundColor: `${userDataMap[objKey].color}20`,
                          }}
                        >
                          <span style={{ color: userDataMap[objKey].color }}>
                            {userDataMap[objKey].icon}
                          </span>
                        </div>
                        <div className="flex-1">
                          <Text strong className="text-gray-600">
                            {userDataMap[objKey].label}
                          </Text>
                          <div className="text-gray-800 font-medium">
                            {user[objKey]}
                          </div>
                        </div>
                      </div>
                    ) : null
                  )}
              </Space>
            </Card>
          </Col>
        </Row>

        {/* Action Buttons */}
        <Card className="shadow-md">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
              <Tooltip title="Cambiar tu contraseña de acceso">
                <Button
                  onClick={handleOpen}
                  block
                  size="large"
                  icon={<LockOutlined />}
                  className="h-12 border-blue-300 text-blue-600 hover:border-blue-500 hover:text-blue-700"
                >
                  Cambiar Contraseña
                </Button>
              </Tooltip>
            </Col>
            <Col xs={24} sm={12}>
              <Tooltip title="Cerrar sesión y salir del sistema">
                <Button
                  type="primary"
                  danger
                  block
                  size="large"
                  icon={<PoweroffOutlined />}
                  onClick={logoutAction}
                  loading={loading}
                  className="h-12"
                >
                  {loading ? 'Cerrando sesión...' : 'Cerrar Sesión'}
                </Button>
              </Tooltip>
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  );
}
function EditProfile(props) {
  const { user, updateUserData } = props;
  return (
    <div className="edit-profile">
      <div className="edit-profile__avatar">
        <Avatar src={NoAvatar} size={200} />
      </div>
      <div className="edit-profile__content">
        <EditProfileForm updateUserData={updateUserData} user={user} />
      </div>
    </div>
  );
}
function EditProfileForm(props) {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);
  const { user, updateUserData } = props;

  const submitEditUser = async () => {
    setLoading(true);
    try {
      const token = getAccessTokenApi();
      const data = { ...form.getFieldsValue(), id: user.rut };
      const editApiResult = await editUserApi(token, data);

      switch (editApiResult.state) {
        case 'success':
          form.resetFields();
          updateUserData();
          notification.success({
            message: '✅ Usuario actualizado correctamente',
            description: 'Los cambios se han guardado exitosamente.',
            placement: 'topRight',
          });
          break;
        case 'error':
          notification.error({
            message: '❌ Error del servidor',
            description: `Por favor registre el siguiente código y envíeselo a soporte. Error: ${editApiResult.codeMessage}`,
            placement: 'topRight',
          });
          break;
        case 'client':
          notification.error({
            message: '❌ Error del cliente',
            description: `Por favor registre el siguiente texto y envíeselo a soporte. Error: ${editApiResult.message}`,
            placement: 'topRight',
          });
          break;
        default:
          notification.error({
            message: '❌ Error del servidor',
            description: `Por favor registre el siguiente código y envíeselo a soporte. Error: ${editApiResult.codeMessage}`,
            placement: 'topRight',
          });
          break;
      }
    } catch (error) {
      notification.error({
        message: '❌ Error inesperado',
        description:
          'Ha ocurrido un error inesperado. Por favor intente nuevamente.',
        placement: 'topRight',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg">
      <div className="mb-6">
        <Title level={3} className="flex items-center space-x-2 mb-2">
          <EditOutlined className="text-blue-500" />
          <span>Editar Perfil</span>
        </Title>
        <Text type="secondary">
          Actualiza tu información personal y de contacto
        </Text>
      </div>

      <Form
        form={form}
        initialValues={user}
        onFinish={submitEditUser}
        layout="vertical"
        size="large"
        className="edit-profile-form"
      >
        <Row gutter={[24, 16]}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="name"
              label={
                <span className="flex items-center space-x-2">
                  <UserOutlined className="text-blue-500" />
                  <span>Nombre</span>
                </span>
              }
              rules={[
                {
                  required: true,
                  message: 'El nombre no puede estar vacío',
                },
                {
                  min: 2,
                  message: 'El nombre debe tener al menos 2 caracteres',
                },
              ]}
            >
              <Input
                placeholder="Ingresa tu nombre"
                prefix={<UserOutlined className="text-gray-400" />}
                className="h-12"
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              name="lastName"
              label={
                <span className="flex items-center space-x-2">
                  <UserOutlined className="text-blue-500" />
                  <span>Apellidos</span>
                </span>
              }
              rules={[
                {
                  required: true,
                  message: 'Los apellidos son obligatorios',
                },
                {
                  min: 2,
                  message: 'Los apellidos deben tener al menos 2 caracteres',
                },
              ]}
            >
              <Input
                placeholder="Ingresa tus apellidos"
                prefix={<UserOutlined className="text-gray-400" />}
                className="h-12"
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name="email"
              label={
                <span className="flex items-center space-x-2">
                  <MailOutlined className="text-blue-500" />
                  <span>Correo Electrónico</span>
                </span>
              }
              rules={[
                {
                  required: true,
                  message: 'El correo es obligatorio',
                },
                {
                  type: 'email',
                  message: 'Debe ingresar un correo electrónico válido',
                },
                {
                  max: 60,
                  message: 'Este campo no puede tener más de 60 caracteres',
                },
              ]}
            >
              <Input
                placeholder="correo@ejemplo.com"
                prefix={<MailOutlined className="text-gray-400" />}
                className="h-12"
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              name="password"
              label={
                <span className="flex items-center space-x-2">
                  <LockOutlined className="text-blue-500" />
                  <span>Nueva Contraseña</span>
                </span>
              }
              rules={[
                {
                  min: 6,
                  message: 'La contraseña debe tener al menos 6 caracteres',
                },
                {
                  max: 40,
                  message: 'Este campo no puede tener más de 40 caracteres',
                },
              ]}
              extra="Deja en blanco si no deseas cambiar la contraseña"
            >
              <Input.Password
                placeholder="Nueva contraseña"
                prefix={<LockOutlined className="text-gray-400" />}
                className="h-12"
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              name="repeatPassword"
              label={
                <span className="flex items-center space-x-2">
                  <LockOutlined className="text-blue-500" />
                  <span>Confirmar Contraseña</span>
                </span>
              }
              rules={[
                {
                  max: 40,
                  message: 'Este campo no puede tener más de 40 caracteres',
                },
                {
                  validator: (_, value) => {
                    const password = form.getFieldValue('password');
                    if (password && password !== value) {
                      return Promise.reject(
                        new Error(
                          'Las contraseñas deben ser exactamente iguales'
                        )
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input.Password
                placeholder="Confirma tu nueva contraseña"
                prefix={<LockOutlined className="text-gray-400" />}
                className="h-12"
              />
            </Form.Item>
          </Col>
        </Row>

        <Divider />

        <Form.Item className="mb-0">
          <div className="flex justify-end space-x-3">
            <Button size="large" className="px-8">
              Cancelar
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={loading}
              icon={<EditOutlined />}
              className="px-8"
            >
              {loading ? 'Guardando...' : 'Guardar Cambios'}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
}
export default Profile;
